module.exports = __webpack_public_path__ + "img/bird-fly-2.e686f1f5.png";